import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceTokenService } from '../services/ui/device-token.service';

@Injectable({
  providedIn: 'root',
})
export class DeviceTokenInterceptor implements HttpInterceptor {
  constructor(private deviceTokenService: DeviceTokenService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const deviceToken = this.deviceTokenService.getOrCreateDeviceToken();
    const lang = navigator.language || 'es-EC';

    const headersToSet: Record<string, string> = {};
    if (!req.headers.has('X-Device-Token')) headersToSet['X-Device-Token'] = deviceToken;
    if (!req.headers.has('X-Lang')) headersToSet['X-Lang'] = lang;

    const updatedReq =
      Object.keys(headersToSet).length > 0 ? req.clone({ setHeaders: headersToSet }) : req;

    return next.handle(updatedReq);
  }
}

export const DEVICE_TOKEN_INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: DeviceTokenInterceptor, multi: true },
];
